import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { errorHandl } from 'src/app/utils/network-utils';
import { urls } from 'src/app/utils/url-utils';
import { environment } from 'src/environments/environment';
import { Router } from "@angular/router";


@Injectable({
  providedIn: 'root'
})
export class SideNavService {

    constructor(private http: HttpClient, private router: Router,) { }

    externalLogin(payload) {
        return this.http.post(`${environment.FLEET_NODE_BASE_URL}auth/login`, payload);
    }
    redirectToExternalApp(token: string) {
    console.log('Redirecting to external app with token:', token);
        const url = `${environment.FLEET_PANEL_BASE_URL}sos?token=${token}`;
        window.open(url, '_blank');
        this.router.navigateByUrl('/dashboard');
    }

    getBrokerSettingList(): Observable<any> {
        return this.http.get<any>(urls.BASE_URL + urls.BROKER_SETTING_URL).pipe(
            catchError(errorHandl)
        );
    }
}
